import { getBuiltinNativeLabel } from "./localeRegistry";

/**
 * Textos da tela de login (pt/en/es/it). Outros idiomas globais usam este bloco em inglês até haver tradução dedicada.
 */
const BY_LANG = {
  pt: {
    welcomeBack: "Bem-vindo de volta!",
    welcome: "Seja bem-vindo!",
    workspaceBanner:
      "Informe o identificador da sua empresa para entrar. É o nome curto da sua conta no Xpro (ex.: minha-loja).",
    loginFailed: "Não foi possível entrar",
    email: "Email",
    invalidEmail: "Email inválido.",
    password: "Senha",
    requiredPassword: "Senha obrigatória.",
    loggingIn: "Entrando...",
    login: "Entrar",
    biometric: "Entrar com Biometria",
    forgotPassword: "Esqueceu sua senha?",
    clickHere: "Clique aqui",
    resetTitle: "Redefinir Senha",
    resetHint: "Insira o email associado à sua conta e enviaremos um link para redefinição de senha.",
    resetErrorTitle: "Erro ao solicitar redefinição",
    resetSuccess: "Um link de redefinição de senha foi enviado ao seu email.",
    cancel: "Cancelar",
    sending: "Enviando...",
    sendLink: "Enviar Link",
    localeLabel: "Idioma da interface",
    noAccount: "Não tem uma conta?",
    createWorkspaceLink: "Criar conta",
    signupTitle: "Criar conta da empresa",
    signupSubtitle: "Escolha um identificador único e seus dados. Você já entra no painel.",
    yourName: "Seu nome",
    workspaceField: "Identificador da empresa",
    signupWorkspaceHint:
      "É o mesmo valor que você usa ao entrar (ex.: minha-loja). Letras minúsculas, números, hífen e underscore.",
    createWorkspaceCta: "Criar conta e entrar",
    creatingWorkspace: "Criando sua conta...",
    smartWorkspaceInvalidHint:
      "Use 2 a 32 caracteres: letras minúsculas, números, ponto, hífen ou underscore (ex.: acme).",
    companyFieldInvalidLogin: "Verifique o identificador da empresa.",
    haveAccount: "Já tem conta?",
    signInInstead: "Entrar",
    passwordHint: "Mínimo de 8 caracteres",
    signupPasswordIntro: "Mesmos requisitos da tela de redefinir senha:",
    signupPwdRuleLen: "Mínimo 8 caracteres",
    signupPwdRuleUpper: "Letra maiúscula",
    signupPwdRuleNum: "Número",
    signupPwdRuleSym: "Símbolo",
    confirmPassword: "Confirmar senha",
    signupPasswordMismatch: "As senhas não coincidem.",
    signupPasswordIncomplete: "A senha deve cumprir todos os requisitos abaixo.",
    invalidName: "Informe seu nome (mínimo 2 caracteres).",
    signupPendingTitle: "Quase lá",
    signupPendingBody:
      "Enviamos um link de confirmação para seu e-mail. Abra o link para ativar o acesso; depois entre com o identificador da empresa e a senha.",
    signupContinueToLogin: "Ir para o login",
    verifyEmailTitle: "Confirmar e-mail",
    verifyEmailWorking: "Confirmando seu e-mail…",
    verifyEmailSuccess: "E-mail confirmado. Você já pode entrar no painel.",
    verifyEmailInvalid: "Link inválido ou expirado. Peça um novo e-mail abaixo.",
    verifyEmailNeedLink: "Use o link enviado por e-mail ou peça um novo abaixo.",
    verifyResendSection: "Reenviar link",
    verifyResendCta: "Enviar novo link",
    verifyResendSent: "Se houver conta pendente, enviaremos um novo link.",
    verifyResendError: "Não foi possível reenviar. Tente mais tarde.",
  },
  en: {
    welcomeBack: "Welcome back!",
    welcome: "Welcome!",
    workspaceBanner:
      "Enter your company identifier to continue. It is the short name of your Xpro account (e.g. my-store).",
    loginFailed: "Could not sign in",
    email: "Email",
    invalidEmail: "Invalid email.",
    password: "Password",
    requiredPassword: "Password is required.",
    loggingIn: "Signing in...",
    login: "Sign in",
    biometric: "Sign in with biometrics",
    forgotPassword: "Forgot your password?",
    clickHere: "Click here",
    resetTitle: "Reset password",
    resetHint: "Enter the email linked to your account and we will send a password reset link.",
    resetErrorTitle: "Error requesting reset",
    resetSuccess: "A password reset link has been sent to your email.",
    cancel: "Cancel",
    sending: "Sending...",
    sendLink: "Send link",
    localeLabel: "Interface language",
    noAccount: "Don't have an account?",
    createWorkspaceLink: "Sign up",
    signupTitle: "Create your company account",
    signupSubtitle: "Pick a unique identifier and your account details. You will land in the app right away.",
    yourName: "Your name",
    workspaceField: "Company identifier",
    signupWorkspaceHint:
      "Same value you use to sign in (e.g. my-store). Lowercase letters, numbers, hyphen and underscore.",
    createWorkspaceCta: "Create account and sign in",
    creatingWorkspace: "Creating your account...",
    smartWorkspaceInvalidHint:
      "Use 2–32 characters: lowercase letters, numbers, period, hyphen or underscore (e.g. acme).",
    companyFieldInvalidLogin: "Please check your company identifier.",
    haveAccount: "Already have an account?",
    signInInstead: "Sign in",
    passwordHint: "At least 8 characters",
    signupPasswordIntro: "Same requirements as the reset-password screen:",
    signupPwdRuleLen: "At least 8 characters",
    signupPwdRuleUpper: "One uppercase letter",
    signupPwdRuleNum: "One number",
    signupPwdRuleSym: "One symbol",
    confirmPassword: "Confirm password",
    signupPasswordMismatch: "Passwords do not match.",
    signupPasswordIncomplete: "Your password must meet every requirement below.",
    invalidName: "Enter your name (at least 2 characters).",
    localePt: "Portuguese (Brazil)",
    localeEn: "English",
    localeEs: "Spanish",
    localeIt: "Italian",
    signupPendingTitle: "Almost there",
    signupPendingBody:
      "We sent a confirmation link to your email. Open it to activate access, then sign in with your company identifier and password.",
    signupContinueToLogin: "Go to login",
    verifyEmailTitle: "Confirm email",
    verifyEmailWorking: "Confirming your email…",
    verifyEmailSuccess: "Email confirmed. You can sign in to the app now.",
    verifyEmailInvalid: "Invalid or expired link. Request a new email below.",
    verifyEmailNeedLink: "Open the link from your email or request a new one below.",
    verifyResendSection: "Resend link",
    verifyResendCta: "Send new link",
    verifyResendSent: "If there is a pending account, we will send a new link.",
    verifyResendError: "Could not resend. Try again later.",
  },
  es: {
    welcomeBack: "¡Bienvenido de nuevo!",
    welcome: "¡Bienvenido!",
    workspaceBanner:
      "Indique el identificador de su empresa para continuar. Es el nombre corto de su cuenta en Xpro (ej.: mi-tienda).",
    loginFailed: "No fue posible iniciar sesión",
    email: "Correo",
    invalidEmail: "Correo no válido.",
    password: "Contraseña",
    requiredPassword: "La contraseña es obligatoria.",
    loggingIn: "Iniciando sesión...",
    login: "Entrar",
    biometric: "Entrar con biometría",
    forgotPassword: "¿Olvidó su contraseña?",
    clickHere: "Haga clic aquí",
    resetTitle: "Restablecer contraseña",
    resetHint: "Ingrese el correo asociado a su cuenta y le enviaremos un enlace para restablecerla.",
    resetErrorTitle: "Error al solicitar restablecimiento",
    resetSuccess: "Se ha enviado un enlace de restablecimiento a su correo.",
    cancel: "Cancelar",
    sending: "Enviando...",
    sendLink: "Enviar enlace",
    localeLabel: "Idioma de la interfaz",
    noAccount: "¿No tiene una cuenta?",
    createWorkspaceLink: "Crear cuenta",
    signupTitle: "Crear cuenta de la empresa",
    signupSubtitle: "Elija un identificador único y sus datos. Entrará al panel de inmediato.",
    yourName: "Su nombre",
    workspaceField: "Identificador de la empresa",
    signupWorkspaceHint:
      "Es el mismo valor que usa al iniciar sesión (ej.: mi-tienda). Minúsculas, números, guion y guion bajo.",
    createWorkspaceCta: "Crear cuenta y entrar",
    creatingWorkspace: "Creando su cuenta...",
    smartWorkspaceInvalidHint:
      "Use de 2 a 32 caracteres: minúsculas, números, punto, guion o guion bajo (ej.: acme).",
    companyFieldInvalidLogin: "Revise el identificador de la empresa.",
    haveAccount: "¿Ya tiene cuenta?",
    signInInstead: "Entrar",
    passwordHint: "Mínimo 8 caracteres",
    signupPasswordIntro: "Mismos requisitos que al restablecer la contraseña:",
    signupPwdRuleLen: "Mínimo 8 caracteres",
    signupPwdRuleUpper: "Una letra mayúscula",
    signupPwdRuleNum: "Un número",
    signupPwdRuleSym: "Un símbolo",
    confirmPassword: "Confirmar contraseña",
    signupPasswordMismatch: "Las contraseñas no coinciden.",
    signupPasswordIncomplete: "La contraseña debe cumplir todos los requisitos siguientes.",
    invalidName: "Indique su nombre (mínimo 2 caracteres).",
    signupPendingTitle: "Casi listo",
    signupPendingBody:
      "Le enviamos un enlace de confirmación por correo. Ábralo para activar el acceso; luego inicie sesión con el identificador de la empresa y la contraseña.",
    signupContinueToLogin: "Ir al inicio de sesión",
    verifyEmailTitle: "Confirmar correo",
    verifyEmailWorking: "Confirmando su correo…",
    verifyEmailSuccess: "Correo confirmado. Ya puede entrar al panel.",
    verifyEmailInvalid: "Enlace no válido o caducado. Solicite uno nuevo abajo.",
    verifyEmailNeedLink: "Use el enlace del correo o solicite uno nuevo abajo.",
    verifyResendSection: "Reenviar enlace",
    verifyResendCta: "Enviar nuevo enlace",
    verifyResendSent: "Si hay una cuenta pendiente, le enviaremos un nuevo enlace.",
    verifyResendError: "No se pudo reenviar. Intente más tarde.",
  },
  it: {
    welcomeBack: "Bentornato!",
    welcome: "Benvenuto!",
    workspaceBanner:
      "Inserisci l'identificativo della tua azienda per continuare. È il nome breve del tuo account Xpro (es.: mio-negozio).",
    loginFailed: "Accesso non riuscito",
    email: "Email",
    invalidEmail: "Email non valida.",
    password: "Password",
    requiredPassword: "Password obbligatoria.",
    loggingIn: "Accesso in corso...",
    login: "Accedi",
    biometric: "Accedi con biometria",
    forgotPassword: "Password dimenticata?",
    clickHere: "Clicca qui",
    resetTitle: "Reimposta password",
    resetHint: "Inserisci l'email collegata al tuo account e ti invieremo un link per reimpostare la password.",
    resetErrorTitle: "Errore nella richiesta di reset",
    resetSuccess: "È stato inviato un link di reimpostazione alla tua email.",
    cancel: "Annulla",
    sending: "Invio in corso...",
    sendLink: "Invia link",
    localeLabel: "Lingua dell'interfaccia",
    noAccount: "Non hai un account?",
    createWorkspaceLink: "Registrati",
    signupTitle: "Crea account aziendale",
    signupSubtitle: "Scegli un identificatore univoco e i tuoi dati. Entrerai subito nel pannello.",
    yourName: "Il tuo nome",
    workspaceField: "Identificativo azienda",
    signupWorkspaceHint:
      "È lo stesso valore che usi per accedere (es.: mio-negozio). Minuscole, numeri, trattino e underscore.",
    createWorkspaceCta: "Crea account e accedi",
    creatingWorkspace: "Creazione account in corso...",
    smartWorkspaceInvalidHint:
      "Usa da 2 a 32 caratteri: minuscole, numeri, punto, trattino o underscore (es.: acme).",
    companyFieldInvalidLogin: "Controlla l'identificativo azienda.",
    haveAccount: "Hai già un account?",
    signInInstead: "Accedi",
    passwordHint: "Almeno 8 caratteri",
    signupPasswordIntro: "Stessi requisiti della schermata di reimpostazione password:",
    signupPwdRuleLen: "Almeno 8 caratteri",
    signupPwdRuleUpper: "Una lettera maiuscola",
    signupPwdRuleNum: "Un numero",
    signupPwdRuleSym: "Un simbolo",
    confirmPassword: "Conferma password",
    signupPasswordMismatch: "Le password non coincidono.",
    signupPasswordIncomplete: "La password deve soddisfare tutti i requisiti qui sotto.",
    invalidName: "Inserisci il nome (almeno 2 caratteri).",
    signupPendingTitle: "Ci siamo quasi",
    signupPendingBody:
      "Ti abbiamo inviato un link di conferma via email. Aprilo per attivare l'accesso, poi accedi con identificativo azienda e password.",
    signupContinueToLogin: "Vai al login",
    verifyEmailTitle: "Conferma email",
    verifyEmailWorking: "Conferma dell'email in corso…",
    verifyEmailSuccess: "Email confermata. Ora puoi accedere al pannello.",
    verifyEmailInvalid: "Link non valido o scaduto. Richiedine uno nuovo qui sotto.",
    verifyEmailNeedLink: "Usa il link ricevuto via email o richiedine uno nuovo qui sotto.",
    verifyResendSection: "Invia di nuovo il link",
    verifyResendCta: "Invia nuovo link",
    verifyResendSent: "Se esiste un account in sospeso, invieremo un nuovo link.",
    verifyResendError: "Impossibile reinviare. Riprova più tardi.",
  },
};

function loginLangKey(localeChoice) {
  const s = String(localeChoice || "pt-BR").toLowerCase();
  if (s.startsWith("pt")) return "pt";
  if (s.startsWith("en")) return "en";
  if (s.startsWith("es")) return "es";
  if (s.startsWith("it")) return "it";
  return "en";
}

export function getLoginUiStrings(localeChoice) {
  return BY_LANG[loginLangKey(localeChoice)];
}

/** Nome amigável do idioma atual (rodapé do login) — vem de localeRegistry. */
export function getLoginLocaleLabel(localeChoice) {
  return getBuiltinNativeLabel(localeChoice);
}
